import { frontendURL } from 'dashboard/helper/URLHelper.js';
import OrbixMonitorFrame from './OrbixMonitorFrame.vue';
import AgentLogs from './AgentLogs.vue';

const meta = {
  permissions: ['administrator', 'agent', 'custom_role'],
};

const reportMeta = {
  permissions: ['administrator', 'report_manage'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/contacts/importacoes'),
    redirect: to => ({
      name: 'orbix_imports',
      params: { accountId: to.params.accountId },
    }),
  },
  {
    path: frontendURL('accounts/:accountId/contacts-orbix/importacoes'),
    name: 'orbix_imports',
    meta,
    component: OrbixMonitorFrame,
    props: {
      title: 'Importações',
      description: 'Importar e acompanhar contatos do Chatwoot.',
      path: 'importacoes',
    },
  },
  {
    path: frontendURL('accounts/:accountId/campaigns/disparos'),
    name: 'orbix_broadcasts',
    meta,
    component: OrbixMonitorFrame,
    props: {
      title: 'Disparos',
      description: 'Simular, testar e enviar campanhas pelo WhatsApp.',
      path: 'disparos',
    },
  },
  {
    path: frontendURL('accounts/:accountId/reports/orbix-dashboard'),
    name: 'orbix_dashboard',
    meta: reportMeta,
    component: OrbixMonitorFrame,
    props: {
      title: 'Dashboard Orbix',
      description: 'Visão operacional do Monitor Orbix.',
      path: '',
    },
  },
  {
    path: frontendURL('accounts/:accountId/reports/orbix-clicks'),
    name: 'orbix_clicks',
    meta: reportMeta,
    component: OrbixMonitorFrame,
    props: {
      title: 'Cliques',
      description: 'Clientes que clicaram nos botões dos templates.',
      path: 'cliques',
    },
  },
  {
    path: frontendURL('accounts/:accountId/reports/orbix-relatorios'),
    name: 'orbix_reports',
    meta: reportMeta,
    component: OrbixMonitorFrame,
    props: {
      title: 'Relatórios Orbix',
      description:
        'Exportações operacionais de conversas, clientes e mensagens.',
      path: 'relatorios',
    },
  },
  {
    path: frontendURL('accounts/:accountId/reports/orbix-versoes'),
    name: 'orbix_versions',
    meta: reportMeta,
    component: OrbixMonitorFrame,
    props: {
      title: 'Relatório de Versões',
      description: 'Resumo das alterações aplicadas no ambiente Orbix.',
      path: 'versoes',
    },
  },
  {
    path: frontendURL('accounts/:accountId/reports/orbix-sobre'),
    name: 'orbix_about',
    meta: reportMeta,
    component: OrbixMonitorFrame,
    props: {
      title: 'Sobre o Sistema',
      description: 'Documentação completa do ambiente Chatwoot/Orbix.',
      path: 'sobre',
    },
  },
  {
    path: frontendURL('accounts/:accountId/reports/orbix-logs'),
    name: 'orbix_logs',
    meta: reportMeta,
    component: AgentLogs,
  },
];
